import http from '../../services/httpAuth'
import getErrorMessage from '../../helpers/getErrorMessage.helper'
import { setServerTimeSuccess } from './timeSettings.slice'
import { setCasinoPopupAllowed } from '../slotCasinoPopUp/slotCasinoPopUp.slice'
import httpAuth from '../../services/httpAuth'

export const requestServerTime = () => async (dispatch) => {
  try {
    const response = await http.get('server-time')
    if (response.data.success) {
      dispatch(setServerTimeSuccess(response.data.result))
    }
    return response
  } catch (e) {
    // const errorMsg = getErrorMessage(e)
    // throw errorMsg
  }
}


export const requestSettings = () => async (dispatch) => {
  try {
    const response = await httpAuth.post('getSetting', {
      siteurl: window.location.hostname
    });
    
    if(response?.data?.success) {
      dispatch(setCasinoPopupAllowed(!!response?.data?.data?.istenpaisa));
    }else {
      dispatch(setCasinoPopupAllowed(false));
    }
  } catch (e) {
    dispatch(setCasinoPopupAllowed(false));
  }
}


